import React from "react";
import { Grid } from "@mui/material";

import Breadcrumb from "Components/Breadcrumb/Breadcrumb";
import { dashboardBreadcrumb } from "Shared/Constants/dashboard";

import VehicleStatus from "../VehicleStatus/VehicleStatus";
import RecentComments from "../RecentComments/RecentComments";
import InspectionSubmission from "../InspectionSubmission/InspectionSubmission";
import InspectionSubmission2 from "../InspectionSubmission2/InspectionSubmission2";
import { ReminderTable } from "../ReminderTable/ReminderTable";
import VehicleMap from "../VehicleMap/VehicleMap";
import VehicleAssignmentDashboard from "../VehicleAssignment/VehicleAssignmentDashboard";
import WorkOrderDNDList from "../WorkOrderDND/WorkOrderDNDList/WorkOrderDNDList";
import IssuesCalendarDashboard from "../IssuesCalendar/IssuesCalendarDashboard";
import styles from "./Main.module.scss";

const Main: React.FC = () => {
  return (
    <>
      <Breadcrumb breads={dashboardBreadcrumb} />
      <Grid container spacing={2} mt="20px">
        <Grid item xs={8}>
          <RecentComments />
        </Grid>
        <Grid item xs={4}>
          <VehicleStatus />
        </Grid>
        <Grid item xs={6}>
          <InspectionSubmission />
        </Grid>
        <Grid item xs={6}>
          <InspectionSubmission2 />
        </Grid>
        <Grid item xs={7}>
          <ReminderTable />
        </Grid>
        <Grid item xs={5}>
          <VehicleMap />
        </Grid>
        <Grid item xs={12} className={styles.issueCalendar}>
          <IssuesCalendarDashboard />
        </Grid>
        <Grid item xs={12} className={styles.vehicleAssignment}>
          <VehicleAssignmentDashboard />
        </Grid>
        <Grid item xs={15} className={styles.workOrderDashboard}>
          <WorkOrderDNDList />
        </Grid>
      </Grid>
    </>
  );
};
export default Main;
